import { createSmartAccountClientFromExisting, getDefaultUserOperationFeeOptions, isSmartAccountWithSigner, } from "@aa-sdk/core";
import { alchemyFeeEstimator } from "../../middleware/feeEstimator.js";
import { alchemyGasManagerMiddleware } from "../../middleware/gasManager.js";
import { alchemyUserOperationSimulator } from "../../middleware/userOperationSimulator.js";
import { alchemyActions } from "../decorators/smartAccount.js";
export function getSignerTypeHeader(account) {
    return { "Alchemy-Aa-Sdk-Signer": account.getSigner().signerType };
}
/**
 * Creates an AlchemySmartAccountClient using the provided RPC client configuration, including options, account, simulation settings, gas management, fee estimation, middleware and user operation signing.
 *
 * @example
 * ```ts
 * import { createAlchemySmartAccountClientFromRpcClient, createAlchemyPublicRpcClient } from "@account-kit/infra";
 *
 * const client = createAlchemyPublicRpcClient(...);
 * const scaClient = createAlchemySmartAccountClientFromRpcClient({
 *  client,
 *  ...
 * });
 * ```
 *
 * @param {CreateAlchemySmartAccountClientFromRpcClientParams} args The configuration object containing all required parameters
 * @returns {AlchemySmartAccountClient} An instance of AlchemySmartAccountClient
 */
export function createAlchemySmartAccountClientFromRpcClient(args) {
    const { opts, account, useSimulation, policyId, feeEstimator, gasEstimator, customMiddleware, signUserOperation, client, } = args;
    const feeOptions = opts?.feeOptions ?? getDefaultUserOperationFeeOptions(client.chain);
    const scaClient = createSmartAccountClientFromExisting({
        account,
        client,
        type: "AlchemySmartAccountClient",
        opts: {
            ...opts,
            feeOptions,
        },
        customMiddleware: async (struct, args) => {
            if (isSmartAccountWithSigner(args.account)) {
                client.updateHeaders(getSignerTypeHeader(args.account));
            }
            return customMiddleware ? customMiddleware(struct, args) : struct;
        },
        feeEstimator: feeEstimator ?? alchemyFeeEstimator(client),
        userOperationSimulator: useSimulation
            ? alchemyUserOperationSimulator(client)
            : undefined,
        gasEstimator,
        ...(policyId && alchemyGasManagerMiddleware(policyId)),
        signUserOperation,
    }).extend(alchemyActions);
    if (account && isSmartAccountWithSigner(account)) {
        client.updateHeaders(getSignerTypeHeader(account));
    }
    return scaClient;
}
//# sourceMappingURL=smartAccountClientFromRpc.js.map